import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTransactionHistory } from '../../../ducks/selectors';
import {
  TransactionHistoryCardWrapper,
  TransactionHistoryTitle,
} from './TransactionHistoryList.styles';
import TransactionHistoryItems from '../../future-packages/transaction-history-items/TransactionHistoryItems';
import { useDualEventTracking } from '../../../utils/useDualEventTracking';

const TransactionHistoryList = () => {
  const { id }: any = useParams();
  const { trackEvent } = useDualEventTracking();

  useEffect(() => {
    trackEvent('TransactionHistory Screen', { vehicleId: id });
  }, []);

  const transactionHistory = useSelector(getTransactionHistory).slice(0);

  return (
    <TransactionHistoryCardWrapper>
      <TransactionHistoryTitle>Transaction History</TransactionHistoryTitle>
      <TransactionHistoryItems
        transactions={transactionHistory}
        shortList={false}
      />
    </TransactionHistoryCardWrapper>
  );
};

export default TransactionHistoryList;
